// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import CollectionActionTypes from './collection-approve.types';
import {
	fetchOfficerListCenters,
	fetchOfficerListArrearCenters,
	fetchBranchCollectionUsersList,
	fetchCenterListOfficerCollections,
	fetchBranchTodayCollectionDetails,
	fetchBranchTodayDemandMoveToArrearList,
	fetchCenterCollectionDenominationDetails,
	fetchAttendanceOfficerCollectionDetails,
	fetchBranchCollectionFunderAllocateEODDetails,
	fetchBranchTodayCollectionsYetToApprove,
	updateLoanPaidPerMemberCollectionApprove,
	updateLoanPaidAllCollectionApprove,
	securityPasswordVerify,
	revertAllocateEOD,
	fetchBranchClosedLoanList,
	commonCollectionUpdate,
	checkBranchEODExist,
	checkBranchEODExistForDate,
	updateLoanPaidMoveToArrear,
	updateOverallAccruedInterestAllocateForEODCall,
	updateOverallAllocateForEODCall,
	fetchGoldLoanCollectionApproveList,
	fetchSavingsCollectionApproveDetails,
	savingsAllocateForApproveUpdate,
	fetchSavingsDenominationDetails,
	updateGoldLoanCollectionApproveDetails,
	updateSavingsCollectionApproveDetails,
	submitApproveStaffTravelDetails,
} from './collection-approve.service';

import {
	getOfficerListCentersSuccess,
	getOfficerListCentersFailure,
	getOfficerListCentersResponseChanged,
	getOfficerListArrearCentersSuccess,
	getOfficerListArrearCentersFailure,
	getOfficerListArrearCentersResponseChanged,
	getBranchCollectionUsersListSuccess,
	getBranchCollectionUsersListFailure,
	getBranchCollectionUsersListResponseChanged,
	getBranchTodayDemandMoveToArrearSuccess,
	getBranchTodayDemandMoveToArrearFailure,
	getBranchTodayDemandMoveToArrearChanged,
	getCenterListOfficerCollectionsSuccess,
	getCenterListOfficerCollectionsFailure,
	getCenterListOfficerCollectionsResponseChanged,
	getBranchTodayCollectionDetailsSuccess,
	getBranchTodayCollectionDetailsFailure,
	getBranchTodayCollectionDetailsChanged,
	getCenterCollectionDenominationSuccess,
	getCenterCollectionDenominationFailure,
	getCenterCollectionDenominationChanged,
	getAttendanceOfficerCollectionSuccess,
	getAttendanceOfficerCollectionFailure,
	getAttendanceOfficerCollectionChanged,
	getBranchCollectionFunderAllocateEODSuccess,
	getBranchCollectionFunderAllocateEODFailure,
	getBranchCollectionFunderAllocateEODChanged,
	getBranchCollectionFunderAllocateEODChangedData,
	getBranchTodayCollectionsYetToApproveSuccess,
	getBranchTodayCollectionsYetToApproveFailure,
	getBranchTodayCollectionsYetToApproveChanged,
	getBranchTodayCollectionsYetToApproveChangedData,
	updateLoanPaidPerMemberCollectionApproveSuccess,
	updateLoanPaidPerMemberCollectionApproveFailure,
	updateLoanPaidPerMemberCollectionApproveResponseChanged,
	updateLoanPaidOverallCollectionApproveSuccess,
	updateLoanPaidOverallCollectionApproveFailure,
	updateLoanPaidOverallCollectionApproveResponseChanged,
	securityCheckPasswordVerifySuccess,
	securityCheckPasswordVerifyFailure,
	securityCheckPasswordVerifyResponseChanged,
	revertAllocateForEodSuccess,
	revertAllocateForEodFailure,
	revertAllocateForEodResponseChanged,
	commonCollectionUpdateSuccess,
	commonCollectionUpdateFailure,
	commonCollectionUpdateResponseChanged,
	checkBranchEODExistSuccess,
	checkBranchEODExistFailure,
	checkBranchEODExistResponseChanged,
	checkBranchEODExistForDateSuccess,
	checkBranchEODExistForDateFailure,
	checkBranchEODExistForDateResponseChanged,
	getBranchClosedLoanListSuccess,
	getBranchClosedLoanListFailure,
	getBranchClosedLoanListChanged,
	updateLoanPaidOverAllMoveToArrearSuccess,
	updateLoanPaidOverAllMoveToArrearFailure,
	updateLoanPaidOverAllMoveToArrearResponseChanged,
	updateOverallAccruedInterestAllocateForEODSuccess,
	updateOverallAccruedInterestAllocateForEODFailure,
	updateOverallAccruedInterestAllocateForEODResponseChanged,
	updateOverallAllocateForEODSuccess,
	updateOverallAllocateForEODFailure,
	updateOverallAllocateForEODResponseChanged,
	fetchGoldLoanCollectionApproveListSuccess,
	fetchGoldLoanCollectionApproveListFailure,
	fetchGoldLoanCollectionApproveListResponseChanged,
	fetchSavingsCollectionApproveDetailsSuccess,
	fetchSavingsCollectionApproveDetailsFailure,
	fetchSavingsCollectionApproveDetailsResponseChanged,
	updateSavingsAllocateForEODSuccess,
	updateSavingsAllocateForEODFailure,
	updateSavingsAllocateForEODResponseChanged,
	fetchSavingsDenominationDetailsSuccess,
	fetchSavingsDenominationDetailsFailure,
	fetchSavingsDenominationDetailsResponseChanged,
	updateGoldLoanCollectionApproveFailure,
	updateGoldLoanCollectionApproveSuccess,
	updateGoldLoanCollectionApproveResponseChanged,
	updateSavingsCollectionApproveFailure,
	updateSavingsCollectionApproveSuccess,
	updateSavingsCollectionApproveResponseChanged,
	submitApproveStaffTravelDetailsSuccess,
	submitApproveStaffTravelDetailsFailure,
	submitApproveStaffTravelDetailsResponseChanged,
} from './collection-approve.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START OFFICER LIST CENTERS DETAILS  ******************** */
export function* getOfficerListCenters({ payload }: any) {
	try {
		const key = 'centerListForOfficerKey';
		const { officerID, BranchID, DatabaseName, whenToPay, selectLoanTab } = payload;
		const jsonData = {
			officerID,
			BranchID,
			DatabaseName,
			whenToPay,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchOfficerListCenters, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getOfficerListCentersFailure(responseData.data));
		} else {
			yield put(getOfficerListCentersSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getOfficerListCentersFailure(error));
	}
}

export function* resetGetOfficerListCentersResponse() {
	yield put(getOfficerListCentersResponseChanged());
}

export function* onGetOfficerListCentersDetails() {
	yield takeLatest(CollectionActionTypes.GET_OFFICER_LIST_CENTERS_START, getOfficerListCenters);
}

export function* onGetOfficerListCentersResponseReset() {
	yield takeLatest(
		CollectionActionTypes.GET_OFFICER_LIST_CENTERS_RESPONSE_RESET,
		resetGetOfficerListCentersResponse,
	);
}
/** *********************  END GET OFFICER LIST CENTERS  ******************** */

/** *********************  START OFFICER LIST ARREAR CENTERS DETAILS  ******************** */
export function* getOfficerListArrearCenters({ payload }: any) {
	try {
		const key = 'arrearCenterListForOfficerKey';
		const { officerID, branchID, databaseName, selectLoanTab } = payload;
		const jsonData = {
			officerID,
			BranchID: branchID,
			DatabaseName: databaseName,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchOfficerListArrearCenters, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getOfficerListArrearCentersFailure(responseData.data));
		} else {
			yield put(getOfficerListArrearCentersSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getOfficerListArrearCentersFailure(error));
	}
}

export function* resetGetOfficerListArrearCentersResponse() {
	yield put(getOfficerListArrearCentersResponseChanged());
}

export function* onGetOfficerListArrearCentersDetails() {
	yield takeLatest(
		CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_START,
		getOfficerListArrearCenters,
	);
}

export function* onGetOfficerListArrearCentersResponseReset() {
	yield takeLatest(
		CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_RESPONSE_RESET,
		resetGetOfficerListArrearCentersResponse,
	);
}
/** *********************  END GET OFFICER LIST ARREAR CENTERS  ******************** */

/** *********************  START BRANCH COLLECTION USERS LIST DETAILS  ******************** */
export function* getBranchCollectionUsersList({ payload }: any) {
	try {
		const key = 'branchCollectionUsersListKey';
		const {
			collectionDate,
			companyID,
			userID,
			userRole,
			branchID,
			databaseName,
			userLevel,
			selectLoanTab,
			activeTabCollectionType,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserLevel: userLevel,
			UserRole: userRole,
			BranchID: branchID,
			DatabaseName: databaseName,
			CollectionDate: collectionDate,
			LoanType: selectLoanTab,
			ActiveTabCollectionType: activeTabCollectionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBranchCollectionUsersList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchCollectionUsersListFailure(responseData.data));
		} else {
			yield put(getBranchCollectionUsersListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchCollectionUsersListFailure(error));
	}
}

export function* resetGetBranchCollectionUsersListResponse() {
	yield put(getBranchCollectionUsersListResponseChanged());
}

export function* onGetBranchCollectionUsersListDetails() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_START,
		getBranchCollectionUsersList,
	);
}

export function* onGetBranchCollectionUsersListResponseReset() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_RESPONSE_RESET,
		resetGetBranchCollectionUsersListResponse,
	);
}
/** *********************  END GET BRANCH COLLECTION USERS LIST  ******************** */

/** *********************  START CENTER LIST FOR OFFICER COLLECTIONS DETAILS  ******************** */
export function* getCenterListOfficerCollections({ payload }: any) {
	try {
		const key = 'centerListOfficerCollectionsKey';
		const {
			officerID,
			branchID,
			databaseName,
			collectionDate,
			selectLoanTab,
			activeTabCollectionType,
		} = payload;
		const jsonData = {
			OfficerID: officerID,
			AreaID: branchID,
			DatabaseName: databaseName,
			WhenToPay: collectionDate,
			LoanType: selectLoanTab,
			ActiveTabCollectionType: activeTabCollectionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchCenterListOfficerCollections, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCenterListOfficerCollectionsFailure(responseData.data));
		} else {
			yield put(getCenterListOfficerCollectionsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCenterListOfficerCollectionsFailure(error));
	}
}

export function* resetGetCenterListOfficerCollectionsResponse() {
	yield put(getCenterListOfficerCollectionsResponseChanged());
}

export function* onGetCenterListOfficerCollectionsDetails() {
	yield takeLatest(
		CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_START,
		getCenterListOfficerCollections,
	);
}

export function* onGetCenterListOfficerCollectionsResponseReset() {
	yield takeLatest(
		CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_RESPONSE_RESET,
		resetGetCenterListOfficerCollectionsResponse,
	);
}
/** *********************  END GET BRANCH COLLECTION USERS LIST  ******************** */

/** *********************  START CENTER LIST FOR OFFICER COLLECTIONS DETAILS  ******************** */
export function* getBranchTodayCollectionDetails({ payload }: any) {
	try {
		const key = 'FetchBranchTodayCollectionDetailsKey';
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			branchID,
			centerID,
			collectionDate,
			officerID,
			infogCompanyID,
			isProductConfigNeed,
			activeTabCollectionType,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			BranchID: branchID,
			CenterID: centerID,
			RePayDate: collectionDate,
			OfficerID: officerID,
			InfogID: infogCompanyID,
			IsProductConfigNeed: isProductConfigNeed,
			CollectionMode: activeTabCollectionType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBranchTodayCollectionDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchTodayCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getBranchTodayCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchTodayCollectionDetailsFailure(error));
	}
}

export function* resetGetBranchTodayCollectionDetailsResponse() {
	yield put(getBranchTodayCollectionDetailsChanged());
}

export function* onGetBranchTodayCollectionDetails() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_START,
		getBranchTodayCollectionDetails,
	);
}

export function* onGetBranchTodayCollectionDetailsReset() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_RESET,
		resetGetBranchTodayCollectionDetailsResponse,
	);
}
/** *********************  END GET BRANCH COLLECTION USERS LIST  ******************** */

/** *********************  START BRANCH TODAY DEMAND MOVE TO ARREAR LIST  ******************** */
export function* getBranchTodayDemandMoveToArrearDetails({ payload }: any) {
	try {
		const key = 'FetchBranchTodayDemandMoveToArrearListKey';
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			branchID,
			centerID,
			collectionDate,
			officerID,
			infogCompanyID,
			isProductConfigNeed,
			activeTabCollectionType,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			BranchID: branchID,
			CenterID: centerID,
			RePayDate: collectionDate,
			OfficerID: officerID,
			InfogID: infogCompanyID,
			IsProductConfigNeed: isProductConfigNeed,
			CollectionMode: activeTabCollectionType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBranchTodayDemandMoveToArrearList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchTodayDemandMoveToArrearFailure(responseData.data));
		} else {
			yield put(getBranchTodayDemandMoveToArrearSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchTodayDemandMoveToArrearFailure(error));
	}
}

export function* resetGetBranchTodayDemandMoveToArrearResponse() {
	yield put(getBranchTodayDemandMoveToArrearChanged());
}

export function* onGetBranchTodayDemandMoveToArrear() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_START,
		getBranchTodayDemandMoveToArrearDetails,
	);
}

export function* onGetBranchTodayDemandMoveToArrearReset() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_RESET,
		resetGetBranchTodayDemandMoveToArrearResponse,
	);
}
/** *********************  END GET BRANCH TODAY DEMAND MOVE TO ARREAR LIST  ******************** */

/** *********************  START BRANCH CLOSED LOAN LIST  ******************** */
export function* getBranchClosedLoanListDetails({ payload }: any) {
	try {
		const key = 'CloseLoanListFetchKey';
		const {
			companyID,
			databaseName,
			userLevel,
			branchID,
			centerID,
			collectionDate,
			officerID,
			activeTabCollectionType,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserLevel: userLevel,
			BranchID: branchID,
			CenterID: centerID,
			RePayDate: collectionDate,
			OfficerID: officerID,
			CollectionMode: activeTabCollectionType,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBranchClosedLoanList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchClosedLoanListFailure(responseData.data));
		} else {
			yield put(getBranchClosedLoanListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchClosedLoanListFailure(error));
	}
}

export function* resetGetBranchClosedLoanListResponse() {
	yield put(getBranchClosedLoanListChanged());
}

export function* onGetBranchClosedLoanList() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_START,
		getBranchClosedLoanListDetails,
	);
}

export function* onGetBranchClosedLoanListReset() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_RESET,
		resetGetBranchClosedLoanListResponse,
	);
}
/** *********************  END GET BRANCH CLOSED LOAN LIST  ******************** */

/** *********************  START CENTER COLLECTION DENOMINATION DETAILS  ******************** */
export function* getCenterCollectionDenomination({ payload }: any) {
	try {
		const key = 'FetchCenterCollectionDenominationKey';
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			branchID,
			centerID,
			selectLoanTab,
			collectionDate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: 'All',
			DenominationDate: collectionDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchCenterCollectionDenominationDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCenterCollectionDenominationFailure(responseData.data));
		} else {
			yield put(getCenterCollectionDenominationSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCenterCollectionDenominationFailure(error));
	}
}

export function* resetGetCenterCollectionDenominationResponse() {
	yield put(getCenterCollectionDenominationChanged());
}

export function* onGetCenterCollectionDenominationDetails() {
	yield takeLatest(
		CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_START,
		getCenterCollectionDenomination,
	);
}

export function* onGetCenterCollectionDenominationDetailsReset() {
	yield takeLatest(
		CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_RESET,
		resetGetCenterCollectionDenominationResponse,
	);
}
/** *********************  END CENTER COLLECTION DENOMINATION DETAILS  ******************** */

/** *********************  START CENTER COLLECTION DENOMINATION DETAILS  ******************** */
export function* getAttendanceOfficerCollection({ payload }: any) {
	try {
		const key = 'FetchAttendanceBasedOfficerCollectionKey';
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			branchID,
			centerID,
			officerID,
			collectionDate,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: 'All',
			OfficerID: officerID,
			RePayDate: collectionDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAttendanceOfficerCollectionDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAttendanceOfficerCollectionFailure(responseData.data));
		} else {
			yield put(getAttendanceOfficerCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAttendanceOfficerCollectionFailure(error));
	}
}

export function* resetGetAttendanceOfficerCollectionResponse() {
	yield put(getAttendanceOfficerCollectionChanged());
}

export function* onGetAttendanceOfficerCollections() {
	yield takeLatest(
		CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_START,
		getAttendanceOfficerCollection,
	);
}

export function* onGetAttendanceOfficerCollectionsReset() {
	yield takeLatest(
		CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_RESET,
		resetGetAttendanceOfficerCollectionResponse,
	);
}
/** *********************  END CENTER COLLECTION DENOMINATION DETAILS  ******************** */

/** *********************  START BRANCH COLLECTION FUNDER ALLLOCATE EOD DETAILS  ******************** */
export function* getBranchCollectionFunderAllocateEOD({ payload }: any) {
	try {
		const key = 'BranchCollectionsAllocateForEodKey';
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			branchID,
			infogCompanyID,
			officerID,
			collectionDate,
			isThrift,
			isProductConfigNeed,
			isIndividualSavings,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			BranchID: branchID,
			InfogID: infogCompanyID,
			OfficerID: officerID,
			RePayDate: collectionDate,
			IsThrift: isThrift,
			IsProductConfigNeed: isProductConfigNeed,
			IsIndividualSavings: isIndividualSavings,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBranchCollectionFunderAllocateEODDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchCollectionFunderAllocateEODFailure(responseData.data));
		} else {
			yield put(getBranchCollectionFunderAllocateEODSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchCollectionFunderAllocateEODFailure(error));
	}
}

export function* resetGetBranchCollectionFunderAllocateEODResponse() {
	yield put(getBranchCollectionFunderAllocateEODChanged());
}

export function* resetGetBranchCollectionFunderAllocateEODDataResponse() {
	yield put(getBranchCollectionFunderAllocateEODChangedData());
}

export function* onGetBranchCollectionFunderAllocateEOD() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_START,
		getBranchCollectionFunderAllocateEOD,
	);
}

export function* onGetBranchCollectionFunderAllocateEODReset() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_RESET,
		resetGetBranchCollectionFunderAllocateEODResponse,
	);
}

export function* onGetBranchCollectionFunderAllocateEODDataReset() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_CHANGED_DATA,
		resetGetBranchCollectionFunderAllocateEODDataResponse,
	);
}
/** *********************  END BRANCH COLLECTION FUNDER ALLLOCATE EOD DETAILS  ******************** */

/** *********************  START BRANCH TODAY COLLECTIONS YET TO APPROVE DETAILS  ******************** */
export function* getBranchTodayCollectionsYetToApprove({ payload }: any) {
	try {
		const key = 'BranchTodayCollectionMembersYetToApproveKey';
		const {
			companyID,
			databaseName,
			userID,
			userLevel,
			branchID,
			infogCompanyID,
			collectionDate,
			funderID,
			productID,
			isProductConfigNeed,
			CollectionMode,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserLevel: userLevel,
			BranchID: branchID,
			InfogID: infogCompanyID,
			RePayDate: collectionDate,
			funderID: funderID,
			productID: productID,
			IsProductConfigNeed: isProductConfigNeed,
			CollectionMode,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBranchTodayCollectionsYetToApprove, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchTodayCollectionsYetToApproveFailure(responseData.data));
		} else {
			yield put(getBranchTodayCollectionsYetToApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchTodayCollectionsYetToApproveFailure(error));
	}
}

export function* resetGetBranchTodayCollectionsYetToApproveResponse() {
	yield put(getBranchTodayCollectionsYetToApproveChanged());
}

export function* resetGetBranchTodayCollectionsYetToApproveDataResponse() {
	yield put(getBranchTodayCollectionsYetToApproveChangedData());
}

export function* onGetBranchTodayCollectionsYetToApprove() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_START,
		getBranchTodayCollectionsYetToApprove,
	);
}

export function* onGetBranchTodayCollectionsYetToApproveReset() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_RESET,
		resetGetBranchTodayCollectionsYetToApproveResponse,
	);
}

export function* onGetBranchTodayCollectionsYetToApproveDataChanged() {
	yield takeLatest(
		CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_CHANGED_DATA,
		resetGetBranchTodayCollectionsYetToApproveDataResponse,
	);
}
/** *********************  END BRANCH TODAY COLLECTIONS YET TO APPROVE DETAILS  ******************** */

/** *********************  START UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE DETAILS  ******************** */
export function* updateLoanDuePerMemberCollectionApprove({ payload }: any) {
	try {
		const key = 'UpdateLoanPaidPerMemberCollectionApproveKey';
		const {
			CompanyID,
			DatabaseName,
			userID,
			userName,
			userLevel,
			BranchID,
			infogCompanyID,
			RePayDate,
			LoanIndexID,
			LoanIndexGroupMemberID,
			MemberID,
			LoanPaidID,
			FunderID,
			DemandCollPrincipal,
			DemandCollInterest,
			DemandCollTotal,
			AdvanceCollPrincipal,
			AdvanceCollInterest,
			AdvanceCollTotal,
			DueNo,
			CollectionMode,
			ApprovedBy,
			ApprovedAmount,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID,
			DatabaseName,
			UserID: userID,
			UserName: userName,
			UserLevel: userLevel,
			BranchID,
			InfogID: infogCompanyID,
			RePayDate,
			LoanIndexID,
			LoanIndexGroupMemberID,
			MemberID,
			LoanPaidID,
			FunderID,
			DemandCollPrincipal,
			DemandCollInterest,
			DemandCollTotal,
			AdvanceCollPrincipal,
			AdvanceCollInterest,
			AdvanceCollTotal,
			DueNo,
			CollectionMode,
			ApprovedBy,
			ApprovedAmount,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateLoanPaidPerMemberCollectionApprove, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateLoanPaidPerMemberCollectionApproveFailure(responseData.data));
		} else {
			yield put(updateLoanPaidPerMemberCollectionApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateLoanPaidPerMemberCollectionApproveFailure(error));
	}
}

export function* resetUpdateLoanPaidPerMemberCollectionApproveResponse() {
	yield put(updateLoanPaidPerMemberCollectionApproveResponseChanged());
}

export function* onUpdateLoanPaidPerMemberCollectionApprove() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_START,
		updateLoanDuePerMemberCollectionApprove,
	);
}

export function* onUpdateLoanPaidPerMemberCollectionApproveReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_RESPONSE_RESET,
		resetUpdateLoanPaidPerMemberCollectionApproveResponse,
	);
}
/** *********************  END UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE  ******************** */

/** *********************  START UPDATE LOAN PAID OVER ALL COLLECTION APPROVE DETAILS  ******************** */
export function* updateLoanPaidOverallCollectionApprove({ payload }: any) {
	try {
		const key = 'UpdateLoanPaidCollectionApproveKey';
		const {
			CompanyID,
			LoanPaidList,
			DatabaseName,
			ApprovedBy,
			ApprovedAmount,
			UserName,
			BranchID,
			LocationID,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID,
			LoanPaidList,
			DatabaseName,
			ApprovedBy,
			ApprovedAmount,
			UserName,
			BranchID,
			LocationID,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateLoanPaidAllCollectionApprove, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateLoanPaidOverallCollectionApproveFailure(responseData.data));
		} else {
			yield put(updateLoanPaidOverallCollectionApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateLoanPaidOverallCollectionApproveFailure(error));
	}
}

export function* resetUpdateLoanPaidOverallCollectionApproveResponse() {
	yield put(updateLoanPaidOverallCollectionApproveResponseChanged());
}

export function* onUpdateLoanPaidOverallCollectionApprove() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_START,
		updateLoanPaidOverallCollectionApprove,
	);
}

export function* onUpdateLoanPaidOverallCollectionApproveReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_RESPONSE_RESET,
		resetUpdateLoanPaidOverallCollectionApproveResponse,
	);
}
/** *********************  END UPDATE LOAN PAID OVER ALL COLLECTION APPROVE  ******************** */

/** *********************  SECURITY CHECK PASSWORD VERIFY DETAILS  ******************** */
export function* securityCheckPasswordVerify({ payload }: any) {
	try {
		const key = 'UserPasscodeVerificationKey';
		const { securityPasswordCheck, userID, CompanyID, DatabaseName, selectLoanTab } = payload;
		const jsonData = {
			CompanyID,
			securityPasswordCheck,
			DatabaseName,
			UserID: userID,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(securityPasswordVerify, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(securityCheckPasswordVerifyFailure(responseData.data));
		} else {
			yield put(securityCheckPasswordVerifySuccess(responseData.data));
		}
	} catch (error) {
		yield put(securityCheckPasswordVerifyFailure(error));
	}
}

export function* resetsecurityCheckPasswordVerifyResponse() {
	yield put(securityCheckPasswordVerifyResponseChanged());
}

export function* onsecurityCheckPasswordVerify() {
	yield takeLatest(
		CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_START,
		securityCheckPasswordVerify,
	);
}

export function* onsecurityCheckPasswordVerifyReset() {
	yield takeLatest(
		CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_RESPONSE_RESET,
		resetsecurityCheckPasswordVerifyResponse,
	);
}
/** *********************  END SECURITY CHECK PASSWORD VERIFY DETAILS  ******************** */

/** *********************  SECURITY CHECK PASSWORD VERIFY DETAILS  ******************** */
export function* revertAllocateForEod({ payload }: any) {
	try {
		const key = 'RevertBranchAllocateForEndOfDayKey';
		const {
			companyID,
			collectionDate,
			databaseName,
			userID,
			branchID,
			userName,
			infogCompanyID,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			AllocateEodDate: collectionDate,
			DatabaseName: databaseName,
			UserID: userID,
			BranchID: branchID,
			CreatedBy: userName,
			InfogID: infogCompanyID,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(revertAllocateEOD, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertAllocateForEodFailure(responseData.data));
		} else {
			yield put(revertAllocateForEodSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertAllocateForEodFailure(error));
	}
}

export function* resetrevertAllocateForEodResponse() {
	yield put(revertAllocateForEodResponseChanged());
}

export function* onrevertAllocateForEod() {
	yield takeLatest(CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_START, revertAllocateForEod);
}

export function* onrevertAllocateForEodReset() {
	yield takeLatest(
		CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_RESPONSE_RESET,
		resetrevertAllocateForEodResponse,
	);
}
/** *********************  END SECURITY CHECK PASSWORD VERIFY DETAILS  ******************** */

/** *********************  START UPDATE LOAN PAID OVER ALL COLLECTION APPROVE DETAILS  ******************** */
export function* commonLoanCollectionUpdate({ payload }: any) {
	try {
		const CollectionLoanArr = JSON.stringify(payload.collectionLoanArr).replace(/"/g, "'");
		const key = 'UpdateCommonLoanPaidDetailsKey';
		const {
			companyID,
			userID,
			userName,
			branchID,
			centerID,
			groupID,
			CollectionDate,
			databaseName,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenomination,
			isAllCenter,
			isGroup,
			paymentFrom,
			paymentMethod,
			selectLoanTab,
			receiptNumber,
			chequeNumber,
			arrearCollectionDate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			CollectionLoanArr,
			CollectionDate,
			DatabaseName: databaseName,
			UserID: userID,
			UserName: userName,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			twoThousand: 0,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			TotalDenomination: totalDenomination,
			IsAllCenter: isAllCenter,
			IsGroup: isGroup,
			collectionPage: paymentFrom,
			paymentMethod,
			LoanType: selectLoanTab,
			arrearCollectionDate: arrearCollectionDate,
			receiptNumber: receiptNumber,
			chequeNumber: chequeNumber,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(commonCollectionUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(commonCollectionUpdateFailure(responseData.data));
		} else {
			yield put(commonCollectionUpdateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(commonCollectionUpdateFailure(error));
	}
}

export function* resetcommonCollectionUpdateApproveResponse() {
	yield put(commonCollectionUpdateResponseChanged());
}

export function* oncommonCollectionUpdateApprove() {
	yield takeLatest(
		CollectionActionTypes.COMMON_COLLECTION_UPDATE_START,
		commonLoanCollectionUpdate,
	);
}

export function* oncommonCollectionUpdateApproveReset() {
	yield takeLatest(
		CollectionActionTypes.COMMON_COLLECTION_UPDATE_RESPONSE_RESET,
		resetcommonCollectionUpdateApproveResponse,
	);
}
/** *********************  END UPDATE LOAN PAID OVER ALL COLLECTION APPROVE  ******************** */

/** *********************  CHECK BRANCH EOD EXIST  ******************** */
export function* checkBranchEODExistStart({ payload }: any) {
	try {
		const key = 'checkBranchEODExistKey';
		const { companyID, databaseName, branchID, inputDate, selectLoanTab } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			InputDate: inputDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkBranchEODExist, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkBranchEODExistFailure(responseData.data));
		} else {
			yield put(checkBranchEODExistSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkBranchEODExistFailure(error));
	}
}

export function* resetcheckBranchEODExistApproveResponse() {
	yield put(checkBranchEODExistResponseChanged());
}

export function* oncheckBranchEODExistApprove() {
	yield takeLatest(CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_START, checkBranchEODExistStart);
}

export function* oncheckBranchEODExistApproveReset() {
	yield takeLatest(
		CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_RESPONSE_RESET,
		resetcheckBranchEODExistApproveResponse,
	);
}
/** *********************  CHECK BRANCH EOD EXIST  ******************** */

/** *********************  CHECK BRANCH EOD FOR DATE EXIST  ******************** */
export function* branchEODExistCheckForDate({ payload }: any) {
	try {
		const key = 'CheckEODDoneForBranchDateKey';
		const { companyID, databaseName, branchID, collectionDate, selectLoanTab } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			CollectionDate: collectionDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkBranchEODExistForDate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkBranchEODExistForDateFailure(responseData.data));
		} else {
			yield put(checkBranchEODExistForDateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkBranchEODExistForDateFailure(error));
	}
}

export function* resetcheckBranchEODExistForDateApproveResponse() {
	yield put(checkBranchEODExistForDateResponseChanged());
}

export function* oncheckBranchEODExistForDateApprove() {
	yield takeLatest(
		CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_START,
		branchEODExistCheckForDate,
	);
}

export function* oncheckBranchEODExistForDateApproveReset() {
	yield takeLatest(
		CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_RESPONSE_RESET,
		resetcheckBranchEODExistForDateApproveResponse,
	);
}
/** *********************  CHECK BRANCH EOD FOR DATE EXIST  ******************** */

/** *********************  START UPDATE LOAN PAID OVER ALL MOVE TO ARREAR DETAILS  ******************** */
export function* updateLoanPaidOverAllMoveToArrear({ payload }: any) {
	try {
		const key = 'loanAllMemberMoveToArrearKey';
		const {
			CompanyID,
			LoanPaidList,
			DatabaseName,
			UserID,
			UserName,
			BranchName,
			CenterName,
			BranchID,
			DemandAmount,
			selectLoanTab,
		} = payload;
		const jsonData = {
			CompanyID,
			LoanPaidList,
			DatabaseName,
			UserID,
			BranchName,
			CenterName,
			UserName,
			BranchID,
			DemandAmount,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateLoanPaidMoveToArrear, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateLoanPaidOverAllMoveToArrearFailure(responseData.data));
		} else {
			yield put(updateLoanPaidOverAllMoveToArrearSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateLoanPaidOverAllMoveToArrearFailure(error));
	}
}

export function* resetUpdateLoanPaidOverAllMoveToArrearResponse() {
	yield put(updateLoanPaidOverAllMoveToArrearResponseChanged());
}

export function* onUpdateLoanPaidOverAllMoveToArrear() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_START,
		updateLoanPaidOverAllMoveToArrear,
	);
}

export function* onUpdateLoanPaidOverAllMoveToArrearReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_RESPONSE_RESET,
		resetUpdateLoanPaidOverAllMoveToArrearResponse,
	);
}
/** *********************  END UPDATE LOAN PAID OVER ALL MOVE TO ARREAR  ******************** */

/** *********************  START UPDATE OVER ALL ACCRUED INTEREST ALLOCATE FOR EOD ******************** */
export function* updateOverallAccruedInterestAllocateForEOD({ payload }: any) {
	try {
		const key = 'UpdateAccruedInterestAllocateForEODKey';
		const {
			CompanyID,
			LoanAccruedInterestList,
			DatabaseName,
			AccruedInterestAmount,
			CreatedBy,
			UserName,
			BranchID,
			CenterID,
			InfogCompanyID,
			GetDueDate,
			selectLoanTab,
		} = payload;

		const jsonData = {
			CompanyID,
			LoanAccruedInterestList,
			DatabaseName,
			AccruedInterestAmount,
			CreatedBy,
			UserName,
			BranchID,
			CenterID,
			InfogCompanyID,
			GetDueDate,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateOverallAccruedInterestAllocateForEODCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateOverallAccruedInterestAllocateForEODFailure(responseData.data));
		} else {
			yield put(updateOverallAccruedInterestAllocateForEODSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateOverallAccruedInterestAllocateForEODFailure(error));
	}
}

export function* resetUpdateOverallAccruedInterestAllocateForEODResponse() {
	yield put(updateOverallAccruedInterestAllocateForEODResponseChanged());
}

export function* onUpdateOverallAccruedInterestAllocateForEOD() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_START,
		updateOverallAccruedInterestAllocateForEOD,
	);
}

export function* onUpdateOverallAccruedInterestAllocateForEODReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_RESPONSE_RESET,
		resetUpdateOverallAccruedInterestAllocateForEODResponse,
	);
}
/** *********************  END UPDATE OVER ALL ACCRUED INTEREST ALLOCATE FOR EOD  ******************** */

/** *********************  START UPDATE OVER ALL ALLOCATE FOR EOD ******************** */
export function* updateOverallAllocateForEOD({ payload }: any) {
	// const WalletAdvanceListArr = JSON.stringify(payload.WalletAdvanceListArr).replace(/"/g, "'");
	// const WalletPayListArr = JSON.stringify(payload.WalletPayListArr).replace(/"/g, "'");
	const WalletPayListArr = JSON.stringify(
		payload.WalletPayListArr && payload.WalletPayListArr.length > 0
			? payload.WalletPayListArr
			: [],
	).replace(/"/g, "'");
	const WalletAdvanceListArr = JSON.stringify(
		payload.WalletAdvanceListArr && payload.WalletAdvanceListArr.length > 0
			? payload.WalletAdvanceListArr
			: [],
	).replace(/"/g, "'");
	const ThriftUsedAmountListArr = JSON.stringify(
		payload.ThriftUsedAmountListArr && payload.ThriftUsedAmountListArr.length > 0
			? payload.ThriftUsedAmountListArr
			: [],
	).replace(/"/g, "'");
	try {
		const key = 'BranchCollectionsAllocateForEODFinanceKey';
		const {
			CompanyID,
			DatabaseName,
			BranchID,
			ProductID,
			FunderID,
			EodDate,
			isProductConfigNeed,
			IsThrift,
			BranchAccountID,
			funderPrincipalAccountID,
			funderInterestAccountID,
			funderPrincipalAmount,
			funderInterestAmount,
			BranchBankAccountID,
			funderBankPrincipalAmount,
			funderBankInterestAmount,
			narrationPrincipal,
			narrationInterest,
			InfogID,
			CreatedBy,
			CreatedFor,
			IsReceipts,
			IsPayments,
			IsCash,
			IsBank,
			bankName,
			chequeNo,
			chequeDate,
			partyBankName,
			partyChequeNo,
			partyChequeDate,
			instrumentID,
			WalletAccountID,
			totalWalletAdvanceAmount,
			ThriftAccountID,
			totalThriftAmount,
			// WalletAdvanceListArr,
			// WalletPayListArr,
			// ThriftUsedAmountListArr,
			LogNotes,
			PenaltyPaidAmount,
			PenaltyAccountID,
			IsTopupPrecloseExists,
			funderJournalPrincipalAmount,
			funderJournalInterestAmount,
			selectLoanTab,
		} = payload;

		const jsonData = {
			CompanyID,
			DatabaseName,
			BranchID,
			ProductID,
			FunderID,
			EodDate,
			IsProductConfigNeed: isProductConfigNeed,
			IsThrift,
			BranchAccountID,
			funderPrincipalAccountID,
			funderInterestAccountID,
			funderPrincipalAmount,
			funderInterestAmount,
			BranchBankAccountID,
			funderBankPrincipalAmount,
			funderBankInterestAmount,
			narrationPrincipal,
			narrationInterest,
			InfogID,
			CreatedBy,
			CreatedFor,
			IsReceipts,
			IsPayments,
			IsCash,
			IsBank,
			bankName,
			chequeNo,
			chequeDate,
			partyBankName,
			partyChequeNo,
			partyChequeDate,
			instrumentID,
			WalletAccountID,
			totalWalletAdvanceAmount,
			ThriftAccountID,
			totalThriftAmount,
			WalletAdvanceListArr,
			WalletPayListArr,
			ThriftUsedAmountListArr,
			LogNotes,
			PenaltyPaidAmount,
			PenaltyAccountID,
			IsTopupPrecloseExists,
			funderJournalPrincipalAmount,
			funderJournalInterestAmount,
			LoanType: selectLoanTab,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateOverallAllocateForEODCall, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateOverallAllocateForEODFailure(responseData.data));
		} else {
			yield put(updateOverallAllocateForEODSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateOverallAllocateForEODFailure(error));
	}
}

export function* resetUpdateOverallAllocateForEODResponse() {
	yield put(updateOverallAllocateForEODResponseChanged());
}

export function* onUpdateOverallAllocateForEOD() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_START,
		updateOverallAllocateForEOD,
	);
}

export function* onUpdateOverallAllocateForEODReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_RESPONSE_RESET,
		resetUpdateOverallAllocateForEODResponse,
	);
}
/** *********************  END UPDATE OVER ALL ALLOCATE FOR EOD  ******************** */

/** *********************  START FETCH GOLD LOAN COLLECTION APPROVE LIST ******************** */
export function* fetchGoldLoanCollectionApproveData({ payload }: any) {
	try {
		const key = 'GoldCollectionMembersForApproveKey';
		const { companyID, databaseName, branchID, officerID, centerID, collectionDate } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			OfficerID: officerID,
			CenterID: centerID,
			RePayDate: collectionDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchGoldLoanCollectionApproveList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGoldLoanCollectionApproveListFailure(responseData.data));
		} else {
			yield put(fetchGoldLoanCollectionApproveListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGoldLoanCollectionApproveListFailure(error));
	}
}

export function* resetFetchGoldLoanCollectionApproveListResponse() {
	yield put(fetchGoldLoanCollectionApproveListResponseChanged());
}

export function* onFetchGoldLoanCollectionApproveList() {
	yield takeLatest(
		CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_START,
		fetchGoldLoanCollectionApproveData,
	);
}

export function* onFetchGoldLoanCollectionApproveListReset() {
	yield takeLatest(
		CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_RESPONSE_RESET,
		resetFetchGoldLoanCollectionApproveListResponse,
	);
}
/** *********************  END FETCH GOLD LOAN COLLECTION APPROVE LIST ******************** */

/** *********************  START FETCH SAVINGS COLLECTION APPROVE DETAILS ******************** */
export function* fetchSavingsCollectionApproveDetailsData({ payload }: any) {
	try {
		const key = 'SavingsCollectionMembersForApproveKey';
		const { companyID, databaseName, branchID, officerID, collectionDate } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			UserID: officerID,
			CollectionDate: collectionDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchSavingsCollectionApproveDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchSavingsCollectionApproveDetailsFailure(responseData.data));
		} else {
			yield put(fetchSavingsCollectionApproveDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchSavingsCollectionApproveDetailsFailure(error));
	}
}

export function* resetFetchSavingsCollectionApproveDetailsResponse() {
	yield put(fetchSavingsCollectionApproveDetailsResponseChanged());
}

export function* onFetchSavingsCollectionApproveDetails() {
	yield takeLatest(
		CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_START,
		fetchSavingsCollectionApproveDetailsData,
	);
}

export function* onFetchSavingsCollectionApproveDetailsReset() {
	yield takeLatest(
		CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_RESPONSE_RESET,
		resetFetchSavingsCollectionApproveDetailsResponse,
	);
}
/** *********************  END FETCH SAVINGS COLLECTION APPROVE DETAILS ******************** */

/** *********************  START UPDATE SAVINGS ALLOCATE FOR EOD ******************** */
export function* updateSavingsAllocateForEODData({ payload }: any) {
	try {
		const key = 'EODApproveForSavingsKey';
		const { companyID, databaseName, branchID, userID, collectionDate, infogCompanyID } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			UserID: userID,
			CollectionDate: collectionDate,
			InfogID: infogCompanyID,
		};
		// eslint-disable-next-line no-debugger
		debugger;
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(savingsAllocateForApproveUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSavingsAllocateForEODFailure(responseData.data));
		} else {
			yield put(updateSavingsAllocateForEODSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSavingsAllocateForEODFailure(error));
	}
}

export function* resetUpdateSavingsAllocateForEODResponse() {
	yield put(updateSavingsAllocateForEODResponseChanged());
}

export function* onUpdateSavingsAllocateForEOD() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_START,
		updateSavingsAllocateForEODData,
	);
}

export function* onUpdateSavingsAllocateForEODReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_RESPONSE_RESET,
		resetUpdateSavingsAllocateForEODResponse,
	);
}
/** *********************  END UPDATE SAVINGS ALLOCATE FOR EOD ******************** */

/** *********************  START FETCH SAVINGS DENOMINATION DETAILS ******************** */
export function* fetchSavingsDenominationDetailsData({ payload }: any) {
	try {
		const key = 'GetSavingsDenominationKey';
		const { companyID, databaseName, branchID, userID, collectionDate } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BranchID: branchID,
			UserID: userID,
			CollectionDate: collectionDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchSavingsDenominationDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchSavingsDenominationDetailsFailure(responseData.data));
		} else {
			yield put(fetchSavingsDenominationDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchSavingsDenominationDetailsFailure(error));
	}
}

export function* resetFetchSavingsDenominationDetailsResponse() {
	yield put(fetchSavingsDenominationDetailsResponseChanged());
}

export function* onFetchSavingsDenominationDetails() {
	yield takeLatest(
		CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_START,
		fetchSavingsDenominationDetailsData,
	);
}

export function* onFetchSavingsDenominationDetailsReset() {
	yield takeLatest(
		CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_RESPONSE_RESET,
		resetFetchSavingsDenominationDetailsResponse,
	);
}
/** *********************  END FETCH SAVINGS DENOMINATION DETAILS ******************** */

/** *********************  START UPDATE GOLD LOAN COLLECTION APPROVE ******************** */
export function* updateGoldLoanCollectionApproveDetailsData({ payload }: any) {
	try {
		const key = 'updateGoldLoanCollectionApproveKey';
		const { companyID, databaseName, userID, goldLoanID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			GoldLoanPaidList: goldLoanID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateGoldLoanCollectionApproveDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateGoldLoanCollectionApproveFailure(responseData.data));
		} else {
			yield put(updateGoldLoanCollectionApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateGoldLoanCollectionApproveFailure(error));
	}
}

export function* resetUpdateGoldLoanCollectionApproveResponse() {
	yield put(updateGoldLoanCollectionApproveResponseChanged());
}

export function* onUpdateGoldLoanCollectionApprove() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_START,
		updateGoldLoanCollectionApproveDetailsData,
	);
}

export function* onUpdateGoldLoanCollectionApproveReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_RESPONSE_RESET,
		resetUpdateGoldLoanCollectionApproveResponse,
	);
}
/** *********************  END UPDATE GOLD LOAN COLLECTION APPROVE ******************** */

/** *********************  START SUBMIT APPROVE STAFF TRAVEL DETAILS ******************** */
export function* submitApproveStaffTravelList({ payload }: any) {
	try {
		const key = 'ApproveStaffTravelDetailsKey';
		const { companyID, branchID, databaseName, eodDate, staffTravel, userID } = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			DatabaseName: databaseName,
			InputDate: eodDate,
			StaffTravelDetails: staffTravel,
			CreatedBy: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(submitApproveStaffTravelDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(submitApproveStaffTravelDetailsFailure(responseData.data));
		} else {
			yield put(submitApproveStaffTravelDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(submitApproveStaffTravelDetailsFailure(error));
	}
}

export function* resetSubmitApproveStaffTravelDetailsResponse() {
	yield put(submitApproveStaffTravelDetailsResponseChanged());
}

export function* onSubmitApproveStaffTravelDetails() {
	yield takeLatest(
		CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_START,
		submitApproveStaffTravelList,
	);
}

export function* onSubmitApproveStaffTravelDetailsResponseReset() {
	yield takeLatest(
		CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_RESPONSE_RESET,
		resetSubmitApproveStaffTravelDetailsResponse,
	);
}
/** *********************  END SUBMIT APPROVE STAFF TRAVEL DETAILS ******************** */

/** *********************  START UPDATE SAVINGS COLLECTION APPROVE ******************** */
export function* updateSavingsCollectionApproveDetailsData({ payload }: any) {
	try {
		const key = 'updateSavingsMemberCollectionApproveKey';
		const { companyID, databaseName, userID, savingsMemberID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			ApprovedBy: userID,
			MemberSavingIDs: savingsMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateSavingsCollectionApproveDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSavingsCollectionApproveFailure(responseData.data));
		} else {
			yield put(updateSavingsCollectionApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSavingsCollectionApproveFailure(error));
	}
}

export function* resetUpdateSavingsCollectionApproveResponse() {
	yield put(updateSavingsCollectionApproveResponseChanged());
}

export function* onUpdateSavingsCollectionApprove() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_START,
		updateSavingsCollectionApproveDetailsData,
	);
}

export function* onUpdateSavingsCollectionApproveReset() {
	yield takeLatest(
		CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_RESPONSE_RESET,
		resetUpdateSavingsCollectionApproveResponse,
	);
}
/** *********************  END UPDATE SAVINGS COLLECTION APPROVE ******************** */

export function* collectionApprovalSaga() {
	yield all([
		call(onGetOfficerListCentersDetails),
		call(onGetOfficerListCentersResponseReset),
		call(onGetOfficerListArrearCentersDetails),
		call(onGetOfficerListArrearCentersResponseReset),
		call(onGetBranchCollectionUsersListDetails),
		call(onGetBranchCollectionUsersListResponseReset),
		call(onGetCenterListOfficerCollectionsDetails),
		call(onGetCenterListOfficerCollectionsResponseReset),
		call(onGetBranchTodayCollectionDetails),
		call(onGetBranchTodayCollectionDetailsReset),
		call(onGetBranchTodayDemandMoveToArrear),
		call(onGetBranchTodayDemandMoveToArrearReset),
		call(onGetCenterCollectionDenominationDetails),
		call(onGetCenterCollectionDenominationDetailsReset),
		call(onGetAttendanceOfficerCollections),
		call(onGetAttendanceOfficerCollectionsReset),
		call(onGetBranchCollectionFunderAllocateEOD),
		call(onGetBranchCollectionFunderAllocateEODReset),
		call(onGetBranchTodayCollectionsYetToApprove),
		call(onGetBranchTodayCollectionsYetToApproveReset),
		call(onUpdateLoanPaidPerMemberCollectionApprove),
		call(onUpdateLoanPaidPerMemberCollectionApproveReset),
		call(onUpdateLoanPaidOverallCollectionApprove),
		call(onUpdateLoanPaidOverallCollectionApproveReset),
		call(onsecurityCheckPasswordVerify),
		call(onsecurityCheckPasswordVerifyReset),
		call(onrevertAllocateForEod),
		call(onrevertAllocateForEodReset),
		call(oncommonCollectionUpdateApprove),
		call(oncommonCollectionUpdateApproveReset),
		call(oncheckBranchEODExistApprove),
		call(oncheckBranchEODExistApproveReset),
		call(oncheckBranchEODExistForDateApprove),
		call(oncheckBranchEODExistForDateApproveReset),
		call(onGetBranchClosedLoanList),
		call(onGetBranchClosedLoanListReset),
		call(onUpdateLoanPaidOverAllMoveToArrear),
		call(onUpdateLoanPaidOverAllMoveToArrearReset),
		call(onUpdateOverallAccruedInterestAllocateForEOD),
		call(onUpdateOverallAccruedInterestAllocateForEODReset),
		call(onUpdateOverallAllocateForEOD),
		call(onUpdateOverallAllocateForEODReset),
		call(onFetchGoldLoanCollectionApproveList),
		call(onFetchGoldLoanCollectionApproveListReset),
		call(onFetchSavingsCollectionApproveDetails),
		call(onFetchSavingsCollectionApproveDetailsReset),
		call(onUpdateSavingsAllocateForEOD),
		call(onUpdateSavingsAllocateForEODReset),
		call(onFetchSavingsDenominationDetails),
		call(onFetchSavingsDenominationDetailsReset),
		call(onUpdateGoldLoanCollectionApprove),
		call(onUpdateGoldLoanCollectionApproveReset),
		call(onUpdateSavingsCollectionApprove),
		call(onUpdateSavingsCollectionApproveReset),
		call(onSubmitApproveStaffTravelDetails),
		call(onSubmitApproveStaffTravelDetailsResponseReset),
	]);
}
